import { render, staticRenderFns } from "./customerIndex.vue?vue&type=template&id=3e9625e3&scoped=true"
import script from "./customerIndex.vue?vue&type=script&lang=js"
export * from "./customerIndex.vue?vue&type=script&lang=js"
import style0 from "./customerIndex.vue?vue&type=style&index=0&id=3e9625e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9625e3",
  null
  
)

export default component.exports